<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else>
      <vx-card>
        <vs-table
          :data="discounts"
          description
          search
          :description-items="descriptionItems"
          :max-items="descriptionItems[0]"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
          @selected="handleSelected"
          pagination
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("setup.label.Discount") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                @click="$router.push({ name: 'Create Discount' })"
                size="small"
                >{{ $t("setup.label.CreateDiscount") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("setup.label.DiscountId") }}</vs-th>
            <vs-th>{{ $t("setup.label.DiscountCode") }}</vs-th>
            <vs-th>{{ $t("setup.label.DiscountName") }}</vs-th>
            <vs-th>{{ $t("setup.label.StartDate") }}</vs-th>
            <vs-th>{{ $t("setup.label.EndDate") }}</vs-th>
            <vs-th>{{ $t("setup.label.Status") }}</vs-th>
            <vs-th>{{ $t("setup.label.ExecutionType") }}</vs-th>
            <vs-th>{{ $t("setup.label.Priority") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="index" :data="item" v-for="(item, index) in data">
              <vs-td :data="item">{{ item.id }}</vs-td>
              <vs-td :data="item">{{ item.code }}</vs-td>
              <vs-td :data="item">{{ item.name }}</vs-td>
              <vs-td :data="item">{{ arrToDate(item.startDate) }}</vs-td>
              <vs-td :data="item">{{ arrToDate(item.endDate) }}</vs-td>
              <vs-td :data="item.status">
                <span
    :class="{
      'status-active': item.status === 'ACTIVE',
      'status-inactive': item.status === 'INACTIVE',
    }"
  >
    {{ item.status }}
  </span>
              </vs-td>
              <vs-td :data="item">{{ item.type }}</vs-td>
              <vs-td :data="item">{{ item.priority }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import moment from "moment";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      discounts: [],
      descriptionItems: [5, 10, 15],
    };
  },
  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  components: { AtomSpinner },
  methods: {
    arrToDate(dateArray) {
      const date = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
      const formattedDate = moment(date).format(this.formattedDate);
      return formattedDate;
    },
    async getDiscountList() {
      this.loading = true;
      try {
        const res = await this.$store.dispatch("discount/fetchDiscountList");
        // this.discounts = res.data.pageItems || [];
        this.discounts = res.data.pageItems.filter(
          (offer) => offer.offerType === "Discount"
        );
      } catch (e) {
        console.log("something went to wrong while getting discount:", e);
      }
      this.loading = false;
    },
    handleSelected(item) {
      this.$router.push({ name: "Discount Detail", params: { id: item.id } });
    },
  },
  created() {
    this.getDiscountList();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
.status-active {
  color: #16a34a;
  font-weight: 600;
}

.status-inactive {
  color: #dc2626;
  font-weight: 600;
}
</style>
